import { lazy } from 'react';

import { LibraryTags, LibraryResources, LibraryTenantSelect } from './library';

const Profile = lazy(() => import('./profile'));
const NotFound = lazy(() => import('./not-found'));
const Tenant = lazy(() => import('./tenants'));
const User = lazy(() => import('./users'));
const UsersLogs = lazy(() => import('./users-logs'));
const ProfileForm = lazy(() => import('./profile-forms'));
const Courses = lazy(() => import('./courses'));
const Project = lazy(() => import('./projects'));
const Reports = lazy(() => import('./reports'));
const GameAnalytics = lazy(() => import('./game-analytics'));
const MessageOrgAdmins = lazy(() => import('./message-org-admins'));
const PdfManagement = lazy(() => import('./pdf-management'));

export {
  User,
  Tenant,
  Courses,
  Profile,
  Project,
  Reports,
  NotFound,
  UsersLogs,
  LibraryTags,
  ProfileForm,
  GameAnalytics,
  PdfManagement,
  LibraryResources,
  MessageOrgAdmins,
  LibraryTenantSelect,
};
